import { Rating, styled } from "@mui/material";

export const StyledRating = styled(Rating)`
  gap: ${(props) => props.theme.wsc.size.xs};

  & .MuiRating-iconFilled {
    color: ${(props) => props.theme.wsc.palette.neutral[100]};
  }

  & .MuiRating-iconEmpty {
    color: ${(props) => props.theme.wsc.palette.neutral[300]};
  }

  &.MuiRating-sizeSmall {
    font-size: 0.857rem;
  }

  &.MuiRating-sizeMedium {
    font-size: 1rem;
  }
`;
